module.exports = __webpack_public_path__ + "static/jakub-014819fb54df55576803a8d160e66fa0.jpg";